import { consoleSandbox } from '@sentry/utils';

/**
 * This is a shim for the Feedback integration.
 * It is needed in order for the CDN bundles to continue working when users add/remove feedback
 * from it, without changing their config. This is necessary for the loader mechanism.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */
class FeedbackShim  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Feedback';}

  /**
   * @inheritDoc
   */

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   constructor(_options) {
    // eslint-disable-next-line deprecation/deprecation
    this.name = FeedbackShim.id;

    consoleSandbox(() => {
      // eslint-disable-next-line no-console
      console.warn('You are using new Feedback() even though this bundle does not include Feedback.');
    });
  }

  /** jsdoc */
   setupOnce() {
    // noop
  }

  /** jsdoc */
   openDialog() {
    // noop
  }

  /** jsdoc */
   closeDialog() {
    // noop
  }

  /** jsdoc */
   attachTo() {
    // noop
  }

  /** jsdoc */
   createWidget() {
    // noop
  }

  /** jsdoc */
   removeWidget() {
    // noop
  }

  /** jsdoc */
   getWidget() {
    // noop
  }
  /** jsdoc */
   remove() {
    // noop
  }
} FeedbackShim.__initStatic();

/**
 * This is a shim for the Feedback integration.
 * It is needed in order for the CDN bundles to continue working when users add/remove feedback
 * from it, without changing their config. This is necessary for the loader mechanism.
 */
function feedbackIntegration(_options) {
  // eslint-disable-next-line deprecation/deprecation
  return new FeedbackShim({});
}

export { FeedbackShim as Feedback, feedbackIntegration };
//# sourceMappingURL=Feedback.js.map
